export const sprintRetrospectiveTool = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare',
  url: 'https://boldare.com',
  description:
    'Digital product design and development company. Boldare offers services such as digital transformation, AI, software development, UX/UI design, MVP, and full cycle product development.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Zwycięstwa 52',
    addressLocality: 'Gliwice',
    postalCode: '44-100',
    addressCountry: 'PL',
  },
  areaServed: 'Worldwide',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Software Development' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Digital Design' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Generative AI' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Product Innovation & Strategy',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Quality & Project Management',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'DevOps & Infrastructure' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Consulting & Scaling' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Testing & Quality' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Dedicated Teams' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Team Augmentation' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product Creation' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'App Accessibility Audit & Implementation Services',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Full Cycle Product Development',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'UX/UI Design' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Code Audit & UX Audit' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product Prototyping' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'MVP Development' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product-Market Fit' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product Scaling' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Development Teams' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'AI Services' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'DevOps Consulting' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'WebApplication',
          name: 'Sprint Retrospective Tool',
          url: 'https://boldare.com/tools/sprint-retrospective',
          description:
            'A free online tool for conducting scrum retrospectives.',
          applicationCategory: 'BusinessApplication',
        },
      },
    ],
  },
};
